export class JSONDummyData {
    public static STRING = "abc...";
    public static NUMBER = 10003;
    public static DATE = new Date();

    public static FILE_NAME = "Appgule.png";
    public static FILE_CONTENT = "Appgule.png";
}

export const ExportShemaFileType: string = "file";
